import { useOutletContext } from "react-router"

const useEditMode = () => {
  const { isEditMode } = useOutletContext<{ isEditMode: boolean }>()
  return isEditMode
}

export { useEditMode }
